import "./src/styles/fonts";
import "./src/styles/global.css";
import * as React from "react";
import { GlobalStyle } from "./src/components/layout/GlobalStyles/GlobalStyles";
import { PageIndexing } from "./src/components/molecules/SEO/PageIndexing";
import { App } from "./src/components/molecules/App/App";
// Fontsource font-variants: https://fontsource.org/docs/variable-fonts

export const wrapPageElement = ({ element, props }) => {
    return (
        <React.Fragment>
            <GlobalStyle />
            <PageIndexing pathname={props.location.pathname} />
            <App {...props}>{element}</App>
        </React.Fragment>
    );
};
